/* jshint ignore:start */

import {
    parsePhoneNumber,
    isValidPhoneNumber
  } from 'libphonenumber-js';


  var Z = window.Z || {};
  Z.settings = Z.settings || {};


  Z.settings = {
      latlon: '',
      latitude: '42.877742', //center of usa //only used when nothing worked
      longitude: '-97.380979', //center of usa
      countryIso: '', //set in data-country attr
      location: null, //set with geocode
      mapJson: null,
      unitsToUse: 'metric',
      //http://complexdan.com/svg-circleellipse-to-path-converter/
  };

  jQuery(function ($) {

      if (typeof google != 'undefined') {
          var geocoder = null;
          var map = null;
          var loading = false;
          var location_query = getParameterByName('location_search');
      }

      function initialize() {
          //set default from geoip plugin
          if ($("#map").data('lat') && $("#map").data('lon')) {

              Z.settings.latitude = $("#map").data('lat');
              Z.settings.longitude = $("#map").data('lon');
              Z.settings.countryIso = $("#map").data('country');
          }

          Z.settings.latlon = Z.settings.latitude + ',' + Z.settings.longitude;

          $("#address-search").submit(function () {
              geoCodeAddress('input'); //uses input value if no param

              return false;
          });

          setupMap();

          if (location_query) {
              //link to search results using    ?location_search=seattle
              $('#address').val(location_query);
              geoCodeAddress('input'); //uses input value
          }

      }

      function loadLocations(type) {
          $('#results').empty();
          $.ajax({
              cache: false,
              //timeout: 8000,
              type: "GET",
              dataType: "json",
              //url: window.nevro.ajaxurl,
              url: window.pf_url + '/wp/wp-admin/admin-ajax.php',
              data: ({
                  action: 'ajax_load_physicians',
                  lat: Z.settings.latitude,
                  lon: Z.settings.longitude,
                  type: type,
                  unit: ($("#map").data('country') == 'US' ? '' : 'K'),
              }),

              success: function (response) {
                  Z.settings.mapJson = response;
                  outputListView();
                  $("#loading").addClass("hidden");
              },

              error: function (jqXHR, textStatus, errorThrown) {
                  $("#loading").addClass("hidden");
              },

              complete: function (jqXHR, textStatus) {
                  //hide loader
                  $("#loading").addClass("hidden");
              }
          });

      }

      function loadLocationsError(message) {
          $('#results').empty();
          $("#loading").addClass("hidden");


          var results = document.getElementById("results");



          results.innerHTML += '<h2 class=" mt-8 text-2xl text-center md:-mb-8 md:text-3xl physician-finder-error-message">'+message+'</h2><br><br><br>';
//        $("#location-container").empty().append("<div>Oh hi mkultra</div>");


          $("#results").removeClass('hidden');


      }

      function setupMap() {
          geocoder = new google.maps.Geocoder();
          map = new google.maps.Map($('.acf-map:first')[0]);
      }

      //triggered by search input
      function geoCodeAddress(location) {
          $("#loading").removeClass("hidden");

          if (loading) {
              return;
          }
          var geocoderConfig = {};
          if (location === 'input') {
              $("#address").blur(); //close keyboard?
              geocoderConfig.address = document.getElementById('address').value;
              if (Z.settings.countryIso) {
                  geocoderConfig.componentRestrictions = {
                      'country': Z.settings.countryIso,
                  };
              }
          } else {
              geocoderConfig.address = location;
          }

          geocoder.geocode(geocoderConfig, function (results, status) {
              let countryCode = physicianFinderReturnCountryCode() ;
              map.setZoom(10);
             
              //only do this if we found good results, or not the USA 
              if(results[0].types.includes('postal_code') || countryCode !== "United States"){
                //set the lon lat here for the ajax call to return values
                Z.settings.latitude = results[0].geometry.location.lat(); //.G;//H
                Z.settings.longitude = results[0].geometry.location.lng(); //.K;//L  can't use letter, google changes it...
                Z.settings.location = results[0].geometry.location;
                map.panTo(Z.settings.location);

                loadLocations();
              }else{
                $("#loading").addClass("hidden");
                loadLocationsError('<p>We couldn\'t find a matching zip code.<br><br class="block md:hidden" />Please double-check the zip code you entered. Thank you!</p>');
              }

              loading = false;
          });

      }

      function buildNodeFromTemplate(location, physician, index) {

          var physicianTemplate = document.querySelector('#physician');
          var clone = physicianTemplate.content.cloneNode(true);

          if(physician.image)
              clone.querySelector('.j-image').innerHTML = `<img src="${physician.image.sizes.thumbnail}" class="object-cover h-full w-full">`;

          clone.querySelectorAll(".j-name").forEach(function(item) {
              item.innerHTML = physician.name;
          });
          clone.querySelectorAll(".j-title").forEach(function(item) {
              item.innerHTML = physician.title;
          });
          clone.querySelector(".j-location-name").innerHTML = location.title;
          clone.querySelector(".j-address").innerHTML = location.address;

          if(location.phone)
          {

              let phoneNumberFormatted = location.phone;

              if(isValidPhoneNumber(location.phone, Z.settings.countryIso)) {
                const phoneNumberParser = parsePhoneNumber(location.phone, Z.settings.countryIso);
                phoneNumberFormatted = phoneNumberParser.format("INTERNATIONAL");
              }
              clone.querySelector(".j-phone .j-link .j-text").innerHTML = phoneNumberFormatted;
              clone.querySelector(".j-phone .j-link").setAttribute('href', `tel:${location.phone}`);
          }
          else
              clone.querySelector(".j-phone").classList.add('hidden');

          if(location.website) {
              let website =  location.website;
              if (!website.match(/^[a-zA-Z]+:\/\//)) website = 'http://' + website;
              clone.querySelector(".j-website .j-link").setAttribute('href', website);
          }
          else
              clone.querySelector(".j-website").classList.add('hidden');

          if(location.fax)
          {
              clone.querySelector(".j-fax .j-link").setAttribute('href', `tel:${location.fax}`);
              clone.querySelector(".j-fax .j-link div").innerHTML = location.fax;
          }
          else
              clone.querySelector(".j-fax").classList.add('hidden');

          if(location.email && false)
          {
              clone.querySelector(".j-email .j-link").setAttribute('href', `mailto:${location.email}`);
              clone.querySelector(".j-email .j-link div").innerHTML = location.email;
          }
          else
              clone.querySelector(".j-email").classList.add('hidden');

          // hide PDN badge if not on PDN or if physician does not have flag
          if(!physician.pdn || !window.location.hostname.match('pdn')) clone.querySelector(".j-pdn").classList.add('hidden');
          clone.querySelector(".j-distance").setAttribute('href', `https://www.google.com/maps/dir//${location.address}`);

          let distanceDisplayValue = location.distance.toFixed(1);
          let plural = 's';
          distanceDisplayValue = distanceDisplayValue.replace('.0', '');
          if(distanceDisplayValue == '1') {
              plural = '';
          }
          if(distanceDisplayValue == '0.0') {
              distanceDisplayValue = '0.1';
          }
          if(clone.querySelector(".j-distance .j-title")){
              clone.querySelector(".j-distance .j-title").innerHTML = distanceDisplayValue + ' mile' + plural + ' away';
          }

          if(clone.querySelector(".j-distance .j-title-usa")){
              clone.querySelector(".j-distance .j-title-usa").innerHTML = distanceDisplayValue + ' mile' + plural + ' away';
          }

          if(clone.querySelector(".j-distance .j-title-australia")){
              clone.querySelector(".j-distance .j-title-australia").innerHTML = distanceDisplayValue + ' kilometer' + plural + ' away';
          }

          if(clone.querySelector(".j-distance .j-title-uk")){
              clone.querySelector(".j-distance .j-title-uk").innerHTML = distanceDisplayValue + ' kilometer' + plural + ' away';
          }

          if(clone.querySelector(".j-distance .j-title-germany")){
              clone.querySelector(".j-distance .j-title-germany").innerHTML = distanceDisplayValue + ' Kilometer' + plural + '  entfernt';
          }

          return clone;
      }

      function outputListView() {
          var outputHtml = '';
          var results = document.getElementById("results");

          for(const [id,location] of Object.entries(Z.settings.mapJson))
          {
              for(const physician of location.physicians)
              {
                  results.appendChild(buildNodeFromTemplate(location, physician, id));
              }
          };

          $("#location-container").empty().append(outputHtml);
          $("#results").removeClass('hidden');
      }

      function getParameterByName(name) {
          name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
          var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
              results = regex.exec(location.search);

          return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
      }

      function submitGTM(pageSlug, pageName, locationURL) {
          dataLayer.push({
              'event': 'VirtualPageview',
              'virtualPageURL': pageSlug,
              'virtualPageTitle': pageName,
              'answer': locationURL,
          });
      }

      if (typeof google != 'undefined') {
          if ($("#map .acf-map").length) {
              google.maps.event.addDomListener(window, 'load', initialize);
          }
      }

      function physicianFinderReturnCountryCode() {
          let countryCode =  $("input[name='patient_assessment_country']").val();
          if(countryCode == "Australia" || countryCode == "United States"){
              return countryCode;
          }
          return "United States";
      }


  });
